import { VoltageSpeedVoltageEpisode } from '../../voltage-with-speed.models';
import { formatEngineOnDuration } from '../kpis/kpis.utils';

export type VoltageAnomalyFilter = 'all' | 'transient' | 'persistent';

function validNumber(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}

export function getVoltageEventTime(value: string): string {
  const match = typeof value === 'string' ? value.match(/(?:^|[T\s])(\d{2}):(\d{2}):(\d{2})(?:$|[.Z+\-\s])/) : null;
  return match && +match[1] < 24 && +match[2] < 60 && +match[3] < 60 ? `${match[1]}:${match[2]}:${match[3]}` : '—';
}

export function buildVoltageAnomalies(episodes: VoltageSpeedVoltageEpisode[]) {
  return episodes.map(episode => {
    const seconds = validNumber(episode.ObservedSpanSeconds);
    const min = validNumber(episode.MinVoltage);
    const max = validNumber(episode.MaxVoltage);
    const validRange = min !== null && max !== null && min <= max;
    return {
      start: getVoltageEventTime(episode.StartTime),
      end: getVoltageEventTime(episode.EndTime),
      startDate: episode.StartTime,
      endDate: episode.EndTime,
      persistent: typeof episode.IsPersistent === 'boolean' ? episode.IsPersistent : null,
      min: validRange ? min : null,
      max: validRange ? max : null,
      duration: seconds === null ? '—' : `${formatEngineOnDuration(seconds)} ${Math.floor(seconds % 60)}s`,
      deviation: validNumber(episode.PeakAbsZScore)
    };
  });
}

export function filterVoltageAnomalies(rows: ReturnType<typeof buildVoltageAnomalies>, filter: VoltageAnomalyFilter) {
  return rows.filter(row => filter === 'all' || row.persistent === (filter === 'persistent'));
}
